define('bindingHandlers/percentPicker',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'bindingHandlers/util/spinnerUtil',
    'extensions/knockoutExtenders/numeric',
    'bindingHandlers/include'
], function (ko, _, moment, spinnerUtil) {
    "use strict";

    /**
     * Percent Picker
     *
     * @description: use for percentage selection; validation would need to be done on the view level
     */

    ko.bindingHandlers.percentPicker = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var self = this;
            //Set the view_template to a default value
            var view_template = 'templates/widgets/percentPicker/percentPicker';
            var value = null;
            var bindingData = valueAccessor();
            // create variable to hold the unit picker template
            var templateData = {};
            var tempHolder = {};
            var valueUnit = "percent";

            //set value
            if (ko.isObservable(bindingData)) {
                value = bindingData;
            }

            //check if value is null; throw descriptive error
            if (value === null) {
                throw new Error("PercentPicker binding error. Must specify as follows: data-bind='percentPicker: observable'");
            }

            tempHolder[valueUnit] = ko.observable(value()).extend({numeric: {precision:0, min:0, max: 100}});

            var unitToPercent = function() {
                var numberPicked;
                _.each(tempHolder, function(unit) {
                    numberPicked = unit();
                });
                return numberPicked;
            };

            //Hold the value as a numeric value
            templateData.selectedValueAsNumeric = ko.computed(function() {
                return(unitToPercent());
            });

            //Update the values as declared above
            templateData.selectedValueAsNumeric.subscribe(function(newValue) {
                if(value() != newValue) {
                    value(newValue);
                }
            });

            value.subscribe(function(newValue) {
                if(newValue < 0) {
                    value(0);
                    return;
                }
            });

            /**
             * this is here so that we are not breaking backwards compatibility, it takes all the values from tempHolder
             * and puts it into templateData
             */
            _.each(tempHolder, function(unit, key){
                templateData[key] = unit;
            });

            // merge the templateData set above with the click handlers from the spinner utility
            _.merge(templateData, spinnerUtil.handleClickDirections(tempHolder, 10));

            var includeValueAccessor = ko.observable({
                name: view_template,
                data: templateData
            });

            ko.bindingHandlers.include.init.call (self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
            ko.bindingHandlers.include.update.call(self, element, includeValueAccessor, allBindings, viewModel, bindingContext);
        }
    };
});

